import ApiHelper from "@/helpsers/api.helper";
import storeCache from "@/js/storeCache";
import UserService from "@/services/user.service";
import axios from "axios";
import { inject, ref } from "vue";

export const API_URL = ApiHelper.returnBackendUrl();
let lang = ref(storeCache.get("lang") || "pl");
let alert = inject("alert");

const instance: any = axios.create({
  baseURL: API_URL,
});

instance.defaults.headers.common["Accept-Language"] =lang.value;

instance.interceptors.request.use(
  (config: any) => {
    const token = storeCache.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    const currentLang = storeCache.get("lang") || "pl";
    config.headers["Accept-Language"] = currentLang

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response: any) => {
    try {
      if (response.data && response.data.data) {
        response.data.data = response.data.data.map((element: any, index: number) => {
          if (response.data.meta) {
            element.lp = (response.data.meta.current_page - 1) * response.data.meta.per_page + (index + 1);
          }
          return element;
        });
      }
    } catch (e) {}
    return response;
  },
  (error: any) => {
    if (error && error.response && error.response.status && error.response.status === 401) {
      try {
        let user = storeCache.get("currentUser");
        if (user && user.role !== "ADMIN" && !storeCache.get("initial_reload")) {
          const userService = new UserService();
          userService.logout();
          if (error.response.data.type && error.response.data.type === "blocked") {
            storeCache.set("showOtherAlert", error.response.data.message);
          } else {
            storeCache.set("showAuthAlert", true);
          }
        }
      } catch (e) {
        console.log(e);
      }
    } else if (error && error.response && error.response.status && error.response.status === 500) {
      window.dispatchEvent(new CustomEvent("show-500-error"));
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export const updateAuthToken = (newToken: string | null) => {
  if (newToken) {
    instance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
  } else {
    delete instance.defaults.headers.common["Authorization"];
  }
};

export const updateLanguage = (newLang: string) => {
  lang.value = newLang;
  instance.defaults.headers.common["Accept-Language"] = newLang === "en" ? "de" : "pl";
};

export default instance;
